import { el } from './dom.js';

/**
 * Exibe um toast de feedback.
 * @param {string} mensagem
 * @param {'sucesso'|'erro'|'info'} [tipo='info']
 * @param {{rotulo?:string, onAcao?:Function, ttl?:number}} [opcoes] - botão de ação opcional (ex.: "Desfazer").
 */
export function toast(mensagem, tipo = 'info', opcoes = {}) {
  const cont = document.getElementById('toasts');
  if (!cont) return;
  const icones = { sucesso: 'ph-check-circle', erro: 'ph-warning-circle', info: 'ph-info' };
  const t = el('div', { class: `toast toast--${tipo}` }, [
    el('i', { class: `ph ${icones[tipo] || icones.info}` }),
    el('span', { text: mensagem }),
  ]);
  let timer;
  const sair = () => {
    t.classList.remove('toast--show');
    setTimeout(() => t.remove(), 300);
  };
  if (opcoes.rotulo && typeof opcoes.onAcao === 'function') {
    t.append(el('button', {
      class: 'toast__acao',
      text: opcoes.rotulo,
      onClick: () => { clearTimeout(timer); opcoes.onAcao(); sair(); },
    }));
  }
  cont.append(t);
  requestAnimationFrame(() => t.classList.add('toast--show'));
  timer = setTimeout(sair, opcoes.ttl || 3500);
}
